<!--
  ~ Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class="user-details">
  <div>
    <h2 *ngIf="isNewUser" class="my-lg title">{{'auth.user.new' | translate}}</h2>
    <h2 *ngIf="!isNewUser" class="my-lg title">{{'auth.user.edit' | translate}}</h2>
  </div>
  <form [formGroup]="userForm">
    <form #form="ngForm">
      <auth-user-form
        [isNewUser]="isNewUser"
        [userData]="userData"
        [emailValue]="emailValue"
        [showPasswords]="showPasswords"
        [phoneNumberRequired]="userData?.companySuperAdmin ?? false"
      >
      </auth-user-form>
    </form>
    <ng-container *ngIf="!firstSignUp">
      <p-table #dt [value]="roleWithRightsVOs"
               dataKey="uuid"
               [lazy]="false"
               [scrollable]="true" scrollHeight="flex" data-testid="uuid-table">
        <ng-template pTemplate="header">
          <tr>
            <th style="max-width: 50px"></th>
            <th style="max-width: 50px">{{'auth.role.assigned' | translate}}</th>
            <th style="max-width: 150px">{{'auth.name' | translate}}</th>
            <th>{{'auth.description' | translate}}</th>
          </tr>
        </ng-template>

        <ng-template let-role pTemplate="body" let-expanded="expanded">
          <tr>
            <td style="max-width: 50px">
              <button type="button" pButton pRipple [pRowToggler]="role"
                      class="p-button-text p-button-rounded p-button-plain"
                      [icon]="expanded ? 'ui-icon-expand-more' : 'ui-icon-chevron-right'" data-testid="btn">
              </button>
            </td>
            <td style="max-width: 50px">
              <p-checkbox [binary]="true" [(ngModel)]="role.selected" [ngModelOptions]="{standalone: true}"
                          (onChange)="onRoleValueChanged($event, role)" data-testid="selected-checkbox">
              </p-checkbox>
            </td>
            <td style="max-width: 150px">{{role.name}}</td>
            <td>{{role.description}}</td>
          </tr>
        </ng-template>

        <ng-template pTemplate="rowexpansion" let-role>
          <ng-container *ngIf="role.uuid"> <!-- usual role -->
            <tr class="child-row">
              <td colspan="4">
                <div class="padding-top padding-left padding-bottom padding-right">
                  <p-table [tableStyle]="{width: '100%'}"
                           [tableStyleClass]="'expanded-area-table-highlight'"
                           [value]="role.rightDefinitions"
                           dataKey="rightName"
                           [lazy]="false" data-testid="right-name-table">

                    <ng-template pTemplate="header">
                      <tr>
                        <th style="max-width: 50px">{{'auth.activeRight' | translate}}</th>
                        <th style="max-width: 150px">{{'auth.rightName' | translate}}</th>
                        <th>{{'auth.description' | translate}}</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-right>
                      <tr>
                        <td style="max-width: 50px">
                          <p-checkbox [binary]="true" [readonly]="true" styleClass="readonly-checkbox"
                                      [(ngModel)]="role.selected" [ngModelOptions]="{standalone: true}" data-testid="selected-checkbox-2"></p-checkbox>
                        </td>
                        <td style="max-width: 150px">{{right.rightLabel}}</td>
                        <td>{{right.description}}</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </td>
            </tr>
          </ng-container>
          <ng-container *ngIf="!role.uuid"> <!-- additional rights row -->
            <tr class="child-row">
              <td colspan="4">
                <div class="padding-top padding-left padding-bottom padding-right">
                  <p-table [tableStyle]="{width: '100%'}"
                           [tableStyleClass]="'expanded-area-table-highlight'"
                           [value]="state.additionalRights"
                           dataKey="rightName"
                           [lazy]="false" data-testid="right-name-table-2">

                    <ng-template pTemplate="header">
                      <tr>
                        <th style="max-width: 50px">{{'auth.activeRight' | translate}}</th>
                        <th style="max-width: 150px">{{'auth.rightName' | translate}}</th>
                        <th>{{'auth.description' | translate}}</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-additionalRight>
                      <ng-container *ngIf="additionalRight.active && additionalRight.right.rightName!== 'ROLE_SELECT_ITEMS_ADMIN'">
                        <tr>
                          <td style="max-width: 50px" *ngIf="additionalRight.readonly">
                            <p-checkbox [binary]="true" [readonly]="true" styleClass="readonly-checkbox"
                                        [(ngModel)]="readOnlyTrueValue"
                                        [ngModelOptions]="{standalone: true}" data-testid="read-only-true-value-checkbox"></p-checkbox>
                          </td>
                          <td style="max-width: 50px" *ngIf="!additionalRight.readonly">
                            <p-checkbox [binary]="true" [(ngModel)]="additionalRight.right.selected"
                                        [ngModelOptions]="{standalone: true}" data-testid="selected-checkbox-3"></p-checkbox>
                          </td>
                          <td style="max-width: 150px">{{additionalRight.right.rightLabel}}</td>
                          <td>{{additionalRight.right.description}}</td>
                        </tr>
                      </ng-container>
                    </ng-template>
                  </p-table>
                </div>

              </td>
            </tr>
          </ng-container>
        </ng-template>

      </p-table>
    </ng-container>
  </form>
</div>
